<template>
  <div>
    <v-toolbar dark flat color="grey-lighten">
      <v-toolbar-title>Atenciones registradas</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog3" persistent max-width="50%">
        <v-card>
          <v-card-text>
            <div v-if="tableDataFiles.length">
              <v-data-table :headers="headersFiles" :items="tableDataFiles" class="elevation-1">
                <template slot="items" slot-scope="props">
                  <td>
                    <a target="_blank" :href="'/descargar/'+props.item">{{ props.item}}</a>
                  </td>
                </template>
              </v-data-table>
            </div>
            <v-alert v-else color="lime darken-3" style="display:block">
              <label>No tiene documentos soportes</label>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog3 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog2" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div class="text-center text-uppercase" role="alert">
              <h1
                class="font-weight-bold text-uppercase"
              >Formulario en línea de Solicitud de Acreditación como víctima del caso 01</h1>
            </div>

            <hr />

            <!-- {{editedItem}} -->

            <section class="my-5" style="display: flex; justify-content: space-between;">
              <small>Fecha radicado: {{editedItem.fecha_registro}}</small>
              <small>Número radicado JEP: {{editedItem.codigo_registro}}</small>
            </section>

            <section class="my-5 section-preview">
              <h2
                class="h1-responsive text-center font-weight-bold text-uppercase my-5"
              >1. Información personal</h2>

              <div class="h1-responsive my-5" v-if="editedItem.solicitud_anterior">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">1.{{reinicioNumeral}}.</span> -->
                  ¿Ha presentado con anterioridad una Solicitud de Acreditación ante la Jurisdicción Especial para la Paz?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.solicitud_anterior}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.no_registro_victima">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                  Si tiene un número de registro ante el Registro Único de Víctimas, por favor indíquelo
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.no_registro_victima}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.formulario_propio">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                  ¿Llena usted por sí mismo este formulario?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.formulario_propio}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.persona_victima">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                  Por favor indique el nombre de la persona que le está ayudando con este Formulario:
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.persona_victima}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.calidad_ayuda">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                  Por favor indique la calidad de la persona que le ayuda a diligenciar este formulario:
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.calidad_ayuda}}</span>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.tipos_documentos_id || editedItem.no_identificacion"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.tipos_documentos_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Tipo documento de la víctima solicitante:
                  </span>
                  <br />
                  <span style="padding: 10px;">
                    <span>{{ editedItem.tipos_documentos.nombre }}</span>
                  </span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.no_identificacion"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Número de identificación de la víctima solicitante:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.no_identificacion}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.nombre_victima_solicitante || editedItem.nombre2_victima_solicitante"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre_victima_solicitante"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Primer nombre de la víctima solicitante:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.nombre_victima_solicitante}}</span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre2_victima_solicitante"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Segundo nombre de la víctima solicitante:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.nombre2_victima_solicitante}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.apellido1_victima_solicitante || editedItem.apellido2_victima_solicitante"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.apellido1_victima_solicitante"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Primer apellido de la víctima solicitante:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.apellido1_victima_solicitante}}</span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.apellido2_victima_solicitante"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Segundo apellido de la víctima solicitante:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.apellido2_victima_solicitante}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.fecha_nacimiento || editedItem.departamento_nacimiento_id || editedItem.municipio_nacimiento_id"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.departamento_nacimiento_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Departamento nacimiento
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.departamento_nacimiento_id.nombre}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.municipio_nacimiento_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Municipio nacimiento
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.municipio_nacimiento_id.nombre}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.fecha_nacimiento"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Fecha nacimiento
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.fecha_nacimiento}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.grupo_etnico || editedItem.nombre_grupo_etnico"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.grupo_etnico"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Pertenencia a un grupo étnico:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.grupo_etnico}}</span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre_grupo_etnico"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Cuál:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.nombre_grupo_etnico}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.organizacion_victimas || editedItem.nombre_organizacion_victimas"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.organizacion_victimas"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Pertenencia a organizacion de victimas:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.organizacion_victimas}}</span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre_organizacion_victimas"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Cuál:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.nombre_organizacion_victimas}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.sujeto_colectivo || editedItem.nombre_sujeto_colectivo"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.sujeto_colectivo"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Pertenencia a un sujeto colectivo que desea acreditarse como víctima:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.sujeto_colectivo}}</span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre_sujeto_colectivo"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Cuál:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.nombre_sujeto_colectivo}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.direccion || editedItem.departamento_id || editedItem.municipio_id"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.departamento_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Departamento residencia
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.departamento_id.nombre}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.municipio_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Municipio residencia
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.municipio_id.nombre}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.direccion"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Direccion residencia
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.direccion}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.telefono_fijo || editedItem.telefono_celular || editedItem.correo"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.telefono_fijo"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Teléfono fijo de residencia
                  </span>
                  <br />
                  <span
                    style="padding: 10px;"
                  >({{editedItem.indicativo}}) - {{editedItem.telefono_fijo}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.telefono_celular"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Teléfono celular
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.telefono_celular}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.correo"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                    Correo electrónico
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.correo}}</span>
                </div>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.ocupacion_actual">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                  Ocupación actual
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.ocupacion_actual}}</span>
              </div>
            </section>

            <section class="my-5 section-preview">
              <h2
                class="h1-responsive text-center font-weight-bold text-uppercase my-5"
              >2. Hechos victimizantes</h2>

              <div class="h1-responsive my-5" v-if="editedItem.hecho_victimizante">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                  Esta solicitud de acreditación la hago en razón de los siguientes hechos victimizantes:
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.hecho_victimizante}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.victima_desaparecida">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                  Indique si la/s víctima/s directa/s fueron dadas por desaparecidas:
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.victima_desaparecida}}</span>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.departamento_hechos_id || editedItem.municipio_hechos_id || editedItem.lugar_hechos"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.departamento_hechos_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                    Departamento de los hechos
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.departamento_hechos_id.nombre}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.municipio_hechos_id"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                    Municipio de los hechos
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.municipio_hechos_id.nombre}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.lugar_hechos"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                    Lugar de los hechos
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.lugar_hechos}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.fecha_hechos_inicio || editedItem.fecha_hechos_fin"
              >
                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.fecha_hechos_inicio"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                    Fecha inicio de los hechos:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.fecha_hechos_inicio}}</span>
                </div>

                <div
                  class="estilo_dos_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.fecha_hechos_fin"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                    Fecha fin de los hechos:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.fecha_hechos_fin}}</span>
                </div>
              </div>
            </section>

            <section class="my-5 section-preview">
              <h2
                class="h1-responsive text-center font-weight-bold text-uppercase my-5"
              >3. Presuntos responsables</h2>

              <div
                class="h1-responsive my-5"
                style="display:flex; flex-wrap: wrap"
                v-if="editedItem.presuntos_responsables"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-for="(item, index) in editedItem.presuntos_responsables"
                  :key="index"
                >
                  <v-card :flat="true" :outlined="true" :raised="true">
                    <v-card-title>Presunto Responsable {{index + 1}}</v-card-title>
                    <v-card-text>
                      <div
                        v-if="item.nombre_responsable || item.nombre2_responsable || item.apellido1_responsable || item.apellido2_responsable"
                      >
                        <span class="font-weight-bold text-uppercase">Nombre:</span>
                        <span>
                          {{item.nombre_responsable}}
                          <span
                            v-if="item.nombre2_responsable"
                          >{{' ' + item.nombre2_responsable}}</span>

                          {{' ' + item.apellido1_responsable}}
                          <span
                            v-if="item.apellido2_responsable"
                          >{{' ' + item.apellido2_responsable}}</span>
                        </span>
                        <br />
                      </div>

                      <div v-if="item.alias_responsable">
                        <span class="font-weight-bold text-uppercase">Alias:</span>
                        <span>{{item.alias_responsable}}</span>
                        <br />
                      </div>

                      <div v-if="item.bloque_id">
                        <span class="font-weight-bold text-uppercase">Bloque:</span>
                        <span>{{item.bloque.nombre}}</span>
                        <br />
                      </div>

                      <div v-if="item.frente_id">
                        <span class="font-weight-bold text-uppercase">Frente:</span>
                        <span>{{item.frente.nombre}}</span>
                        <br />
                        <br />
                      </div>

                      <div v-if="item.observaciones">
                        <span class="font-weight-bold text-uppercase">Información adicional:</span>
                        <p class="card-text text-justify">{{item.observaciones}}</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </section>

            <section class="my-5 section-preview">
              <h2
                class="h1-responsive text-center font-weight-bold text-uppercase my-5"
              >4. Familiares / Allegados</h2>

              <div
                class="h1-responsive my-5"
                style="display:flex; flex-wrap: wrap"
                v-if="editedItem.allegados_familiares"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-for="(item, index) in editedItem.allegados_familiares"
                  :key="index"
                >
                  <v-card :flat="true" :outlined="true" :raised="true">
                    <v-card-title>Familiar o allegado {{index + 1}}</v-card-title>
                    <v-card-text>
                      <div
                        v-if="item.nombre_allegado || item.nombre2_allegado || item.apellido1_allegado || item.apellido2_allegado"
                      >
                        <span class="font-weight-bold text-uppercase">Nombre:</span>
                        <span>
                          {{item.nombre_allegado}}
                          <span
                            v-if="item.nombre2_allegado"
                          >{{' ' + item.nombre2_allegado}}</span>

                          {{' ' + item.apellido1_allegado}}
                          <span
                            v-if="item.apellido2_allegado"
                          >{{' ' + item.apellido2_allegado}}</span>
                        </span>
                        <br />
                      </div>

                      <div v-if="item.documento_allegado">
                        <span class="font-weight-bold text-uppercase">Documento:</span>
                        <span>{{item.documento_allegado}}</span>
                        <br />
                      </div>

                      <div v-if="item.parentezco_allegado">
                        <span class="font-weight-bold text-uppercase">Parentesco:</span>
                        <span>{{item.parentezco_allegado}}</span>
                        <br />
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </section>

            <section class="my-5 section-preview">
              <h2
                class="h1-responsive text-center font-weight-bold text-uppercase my-5"
              >5. Sobre la representación legal</h2>

              <div class="h1-responsive my-5" v-if="editedItem.abogado_confianza">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                  ¿Cuenta usted con un abogado de confianza que lo represente en el proceso?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.abogado_confianza}}</span>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.abogado_confianza == 'Si' && ( (editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado) || editedItem.direccion_abogado || editedItem.telefono_abogado)"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Nombre del abogado:
                  </span>
                  <br />
                  <span style="padding: 10px;">
                    {{editedItem.nombre_abogado}}
                    <span
                      v-if="editedItem.nombre2_abogado"
                    >{{' ' + editedItem.nombre2_abogado}}</span>

                    {{' ' + editedItem.apellido1_abogado}}
                    <span
                      v-if="editedItem.apellido2_abogado"
                    >{{' ' + editedItem.apellido2_abogado}}</span>
                  </span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.direccion_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Dirección de notificación
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.direccion_abogado}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.telefono_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Teléfono de contacto
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.telefono_abogado}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.abogado_confianza == 'Si' && (editedItem.celular_abogado || editedItem.correo_abogado || editedItem.poder_abogado)"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.celular_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Celular de contacto:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.celular_abogado}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.correo_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Correo electrónico:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.correo_abogado}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.poder_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Anexa poder especial:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.poder_abogado}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep"
              >
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                  Representado actualmente por la JEP:
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.representado_actualmente_jep}}</span>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'Si' && ( (editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado) || editedItem.direccion_abogado || editedItem.telefono_abogado)"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Nombre del abogado:
                  </span>
                  <br />
                  <span style="padding: 10px;">
                    {{editedItem.nombre_abogado}}
                    <span
                      v-if="editedItem.nombre2_abogado"
                    >{{' ' + editedItem.nombre2_abogado}}</span>

                    {{' ' + editedItem.apellido1_abogado}}
                    <span
                      v-if="editedItem.apellido2_abogado"
                    >{{' ' + editedItem.apellido2_abogado}}</span>
                  </span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.direccion_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Dirección de notificación
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.direccion_abogado}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.telefono_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Teléfono de contacto
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.telefono_abogado}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
                v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'Si' && (editedItem.celular_abogado || editedItem.correo_abogado)"
              >
                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.celular_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Celular de contacto:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.celular_abogado}}</span>
                </div>

                <div
                  class="estilo_tres_columnas"
                  style="padding-left:0px;"
                  v-if="editedItem.correo_abogado"
                >
                  <span class="font-weight-bold text-uppercase">
                    <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                    Correo electrónico:
                  </span>
                  <br />
                  <span style="padding: 10px;">{{editedItem.correo_abogado}}</span>
                </div>
              </div>

              <div
                class="h1-responsive my-5"
                v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'No' && editedItem.manifiesta_interes"
              >
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                  Manifiesta su interés en ser representado/a por un abogado común del Sistema Autónomo de Asesoría y Representación Legal de la JEP?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.manifiesta_interes}}</span>
              </div>

              <div
                class="h1-responsive my-5"
                v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'No' && editedItem.manifiesta_interes == 'No' && editedItem.voluntad_actuar_solo"
              >
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                  Manifiesta su voluntad de actuar por sí mismo/a en el proceso ante la JEP?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.voluntad_actuar_solo}}</span>
              </div>

              <div
                class="h1-responsive my-5"
                v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'No' && editedItem.manifiesta_interes == 'No' && editedItem.voluntad_actuar_solo == 'No' && editedItem.medio_representacion"
              >
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                  Por favor, indique qué otro medio de representación judicial usará:
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.medio_representacion}}</span>
              </div>
            </section>

            <section class="my-5 section-preview">
              <h2
                class="h1-responsive text-center font-weight-bold text-uppercase my-5"
              >6. Protección y seguridad</h2>

              <div class="h1-responsive my-5" v-if="editedItem.riesgo_seguridad">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                  ¿Las víctimas solicitantes tienen alguna razón para temer por su seguridad, integridad, dignidad o bienestar actualmente, o identifica riesgos por el inicio de este proceso de acreditación ante la Jurisdicción Especial para la Paz?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.riesgo_seguridad}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.razones_riesgo_seguridad">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                  ¿Cuáles son las razones?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.razones_riesgo_seguridad}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.riesgo_seguridad_pruebas">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                  ¿La víctima solicitante o sus familiares y/o allegados tienen alguna razón para temer por la seguridad o integridad o algún riesgo sobre la información, archivos, objetos o lugares que puedan representar interés probatorio o de información de contexto para el inicio de este proceso de acreditación ante la Jurisdicción Especial para la Paz?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.riesgo_seguridad_pruebas}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.razones_riesgo_seguridad_pruebas">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                  ¿Cuáles son las razones?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.razones_riesgo_seguridad_pruebas}}</span>
              </div>

              <div class="h1-responsive my-5" v-if="editedItem.autoriza_notificacion">
                <span class="font-weight-bold text-uppercase">
                  <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                  ¿Autoriza a ser notificado de las actuaciones de este caso por medios electrónicos?
                </span>
                <br />
                <span style="padding: 10px;">{{editedItem.autoriza_notificacion}}</span>
              </div>
            </section>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog2 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog4" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE DESPACHO</h4>
            </div>

            <h5 class="headline mb-0 text-center">ACREDITACIÓN VÍCTIMA PRINCIPAL</h5>
            <section class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItem.estado"
                    :items="estados"
                    label="Estado"
                    item-text="estado"
                    item-value="estado"
                    :rules="requiredRules"
                  ></v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu
                    v-model="menu_fecha_acreditacion"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    label="Fecha auto de acreditación"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItem.fecha_acreditacion"
                        label="Fecha auto de acreditación"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="editedItem.fecha_acreditacion"
                      @input="menu_fecha_acreditacion = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <v-textarea
                v-model="editedItem.doc_faltantes"
                label="Documentos faltantes:"
                hint="Brinde por favor las observaciones necesarias a los documentos faltantes."
              ></v-textarea>

              <v-textarea
                v-model="editedItem.observaciones"
                label="Observaciones:"
                hint="Brinde por favor las observaciones necesarias."
              ></v-textarea>
            </section>

            <h5 class="headline mb-0 text-center">ACREDITACIÓN FAMILIARES Y/0 ALLEGADOS</h5>
            <section class="my-5 section-preview">
              <span v-if="editedItem.allegados_familiares.length">
                <div v-for="(item, index) in editedItem.allegados_familiares" :key="index">
                  <v-alert color="blue-grey" style="display:block">
                    <div
                      class="h1-responsive text-uppercase"
                      style="display:flex; justify-content: space-between;"
                    >
                      <div class="estilo_tres_columnas" style="padding-left:0px;">
                        <v-badge color="blue-grey darken-2">
                          <template v-slot:badge>{{index + 1}}.</template>
                        </v-badge>
                        <span
                          v-if="item.documento_allegado"
                          style="padding-left:25px;"
                        >Número documento: {{item.documento_allegado}}</span>
                        <span
                          v-if="item.parentezco_allegado"
                          style="padding-left:28px;"
                        >Parentesco: {{item.parentezco_allegado}}</span>
                      </div>

                      <div class="estilo_tres_columnas text-center" style="padding-left:0px;">
                        <span
                          v-if="item.nombre_allegado || item.nombre2_allegado || item.apellido1_allegado || item.apellido2_allegado"
                        >
                          Nombre completo:
                          <br />
                        </span>
                        <span v-if="item.nombre_allegado">{{item.nombre_allegado}}</span>
                        <span v-if="item.nombre2_allegado">{{item.nombre2_allegado}}</span>
                        <span v-if="item.apellido1_allegado">{{item.apellido1_allegado}}</span>
                        <span v-if="item.apellido2_allegado">{{item.apellido2_allegado}}</span>
                      </div>

                      <div class="estilo_tres_columnas text-right" style="padding-left:0px;">
                        <span>
                          Acreditación:
                          <br />
                        </span>
                        <v-icon
                          large
                          color="red accent-4"
                          v-if="item.estado_allegado==='No acreditada'"
                          @click="gestionDespachoAcreditacionFamiliar(index, item)"
                        >verified_user</v-icon>
                        <v-icon
                          large
                          color="green accent-4"
                          v-else-if="item.estado_allegado==='Acreditada'"
                          @click="gestionDespachoAcreditacionFamiliar(index, item)"
                        >verified_user</v-icon>
                        <v-icon
                          large
                          color="yellow accent-4"
                          v-else
                          @click="gestionDespachoAcreditacionFamiliar(index, item)"
                        >verified_user</v-icon>
                      </div>
                    </div>
                  </v-alert>
                </div>
              </span>
              <v-alert v-else color="lime darken-3" style="display:block">
                <label>No tiene familiares ni allegados registrados</label>
              </v-alert>
            </section>

            <h5 class="headline mb-0 text-center">INFORMACIÓN ADICIONAL</h5>
            <section class="my-5 section-preview">
              <v-textarea
                v-model="editedItem.demanda_verdad"
                label="Demanda de verdad:"
                hint="Brinde por favor la información correspondiente a la demanda de verdad."
              ></v-textarea>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Responsable" v-model="editedItem.responsable"></v-text-field>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Radicado salida" v-model="editedItem.radicado_salida"></v-text-field>
                </div>
              </div>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog4 = false">Cancelar</v-btn>
            <v-btn color="primary" @click.prevent="update" v-if="boton_guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog6" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE DESPACHO</h4>
            </div>

            <h5 class="headline mb-0 text-center">ACREDITACIÓN FAMILIAR Y/O ALLEGADO</h5>
            <section class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItemAllegado.estado_allegado"
                    :items="estados"
                    label="Estado"
                    item-text="estado"
                    item-value="estado"
                    :rules="requiredRules"
                  ></v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu
                    v-model="menu_fecha_acreditacion_allegado"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    label="Fecha auto de acreditación"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItemAllegado.fecha_acreditacion_allegado"
                        label="Fecha auto de acreditación"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="editedItemAllegado.fecha_acreditacion_allegado"
                      @input="menu_fecha_acreditacion_allegado = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <v-textarea
                v-model="editedItemAllegado.observaciones_allegado"
                label="Observaciones:"
                hint="Brinde por favor las observaciones necesarias."
              ></v-textarea>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog6 = false">Cancelar</v-btn>
            <v-btn color="primary" @click.prevent="updateAllegado()" v-if="boton_guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog5" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DEL DESPACHO</h4>
            </div>

            <h5
              class="headline mb-0 text-center"
            >RECONOCIMIENTO PERSONERÍA JURÍDICA VÍCTIMA PRINCIPAL</h5>

            <section class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItem.reconocimiento_personeria_juridica"
                    :items="reconocimiento_personeria_juridica"
                    label="Reconocimiento personería jurídica"
                    item-text="Reconocimiento personería jurídica"
                    item-value="Reconocimiento personería jurídica"
                    :rules="requiredRules"
                  ></v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu
                    v-model="menu_fecha_auto_reconocimiento_personeria_juridica"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItem.fecha_auto_reconocimiento_personeria_juridica"
                        label="Fecha auto de reconocimiento de personería jurídica"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="editedItem.fecha_auto_reconocimiento_personeria_juridica"
                      @input="menu_fecha_auto_reconocimiento_personeria_juridica = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <div v-if="editedItem.reconocimiento_personeria_juridica === 'Reconocida'">
                <v-divider class="mx-1"></v-divider>
                <label>Nombre del abogado reconocido:</label>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Primer nombre"
                      v-model="editedItem.nombre_abogado_reconocido"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Segundo nombre"
                      v-model="editedItem.nombre2_abogado_reconocido"
                    ></v-text-field>
                  </div>
                </div>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Primer apellido"
                      v-model="editedItem.apellido1_abogado_reconocido"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Segundo apellido"
                      v-model="editedItem.apellido2_abogado_reconocido"
                    ></v-text-field>
                  </div>
                </div>

                <v-divider class="mx-1"></v-divider>
                <label>Datos de contacto del abogado reconocido:</label>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Dirección de notificación"
                      v-model="editedItem.direccion_abogado_reconocido"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Teléfono de contacto"
                      v-model="editedItem.telefono_abogado_reconocido"
                    ></v-text-field>
                  </div>
                </div>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Celular de contacto"
                      v-model="editedItem.celular_abogado_reconocido"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Correo electrónico"
                      v-model="editedItem.correo_abogado_reconocido"
                    ></v-text-field>
                  </div>
                </div>
              </div>

              <v-divider class="mx-1"></v-divider>

              <v-textarea
                v-model="editedItem.auto_reconocimiento_personeria_juridica"
                label="Auto reconocimiento personería jurídica:"
                hint="Brinde por favor la información correspondiente al auto de reconocimiento de personería jurídica."
              ></v-textarea>
            </section>

            <h5
              class="headline mb-0 text-center"
            >RECONOCIMIENTO PERSONERÍA JURÍDICA FAMILIARES Y/0 ALLEGADOS</h5>

            <section class="my-5 section-preview">
              <span v-if="editedItem.allegados_familiares.length">
                <div v-for="(item, index) in editedItem.allegados_familiares" :key="index">
                  <v-alert color="blue-grey" style="display:block">
                    <div
                      class="h1-responsive text-uppercase"
                      style="display:flex; justify-content: space-between;"
                    >
                      <div class="estilo_tres_columnas" style="padding-left:0px;">
                        <v-badge color="blue-grey darken-2">
                          <template v-slot:badge>{{index + 1}}.</template>
                        </v-badge>
                        <span
                          v-if="item.documento_allegado"
                          style="padding-left:25px;"
                        >Número documento: {{item.documento_allegado}}</span>
                        <span
                          v-if="item.parentezco_allegado"
                          style="padding-left:28px;"
                        >Parentesco: {{item.parentezco_allegado}}</span>
                      </div>

                      <div class="estilo_tres_columnas text-center" style="padding-left:0px;">
                        <span
                          v-if="item.nombre_allegado || item.nombre2_allegado || item.apellido1_allegado || item.apellido2_allegado"
                        >
                          Nombre completo:
                          <br />
                        </span>
                        <span v-if="item.nombre_allegado">{{item.nombre_allegado}}</span>
                        <span v-if="item.nombre2_allegado">{{item.nombre2_allegado}}</span>
                        <span v-if="item.apellido1_allegado">{{item.apellido1_allegado}}</span>
                        <span v-if="item.apellido2_allegado">{{item.apellido2_allegado}}</span>
                      </div>

                      <div class="estilo_tres_columnas text-center" style="padding-left:0px;">
                        <span>
                          Reconocimiento personería jurídica:
                          <br />
                        </span>
                        <v-icon
                          large
                          color="green accent-4"
                          v-if="item.abogado_reconocido_victima_principal==='Sí' || (item.abogado_reconocido_victima_principal==='No' && item.reconocimiento_personeria_juridica_allegado==='Reconocida')"
                          @click="gestionDespachoReconocimientoFamiliar(index, item)"
                        >verified_user</v-icon>
                        <v-icon
                          large
                          color="red accent-4"
                          v-else-if="item.abogado_reconocido_victima_principal==='No' && item.reconocimiento_personeria_juridica_allegado==='No reconocida'"
                          @click="gestionDespachoReconocimientoFamiliar(index, item)"
                        >verified_user</v-icon>
                        <v-icon
                          large
                          color="red accent-4"
                          v-else
                          @click="gestionDespachoReconocimientoFamiliar(index, item)"
                        >verified_user</v-icon>
                      </div>
                    </div>
                  </v-alert>
                </div>
              </span>
              <v-alert v-else color="lime darken-3" style="display:block">
                <label>No tiene familiares ni allegados registrados</label>
              </v-alert>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog5 = false">Cancelar</v-btn>
            <v-btn color="primary" @click.prevent="update" v-if="boton_guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog7" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE DESPACHO</h4>
            </div>

            <h5
              class="headline mb-0 text-center"
            >RECONOCIMIENTO PERSONERÍA JURÍDICA FAMILIAR Y/O ALLEGADO</h5>
            <section class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItemAllegado.abogado_reconocido_victima_principal"
                    :items="abogado_reconocido_victima_principal"
                    label="¿El abogado reconocido es el mismo de la víctima principal?"
                    item-text="Indique sí el abogado reconocido es el mismo que presentó la víctima principal"
                    item-value="Indique sí el abogado reconocido es el mismo que presentó la víctima principal"
                    :rules="requiredRules"
                  ></v-select>
                </div>
              </div>

              <div
                v-if="editedItemAllegado.abogado_reconocido_victima_principal === 'No'"
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
              >
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItemAllegado.reconocimiento_personeria_juridica_allegado"
                    :items="reconocimiento_personeria_juridica"
                    label="Reconocimiento personería jurídica"
                    item-text="Reconocimiento personería jurídica"
                    item-value="Reconocimiento personería jurídica"
                    :rules="requiredRules"
                  ></v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu
                    v-model="menu_fecha_auto_reconocimiento_personeria_juridica_allegado"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItemAllegado.fecha_auto_reconocimiento_personeria_juridica_allegado"
                        label="Fecha auto de reconocimiento de personería jurídica"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="editedItemAllegado.fecha_auto_reconocimiento_personeria_juridica_allegado"
                      @input="menu_fecha_auto_reconocimiento_personeria_juridica_allegado = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <div
                v-if="editedItemAllegado.abogado_reconocido_victima_principal === 'No' && editedItemAllegado.reconocimiento_personeria_juridica_allegado === 'Reconocida'"
              >
                <v-divider class="mx-1"></v-divider>
                <label>Nombre del abogado reconocido:</label>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Primer nombre"
                      v-model="editedItemAllegado.nombre_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Segundo nombre"
                      v-model="editedItemAllegado.nombre2_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Primer apellido"
                      v-model="editedItemAllegado.apellido1_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Segundo apellido"
                      v-model="editedItemAllegado.apellido2_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>

                <v-divider class="mx-1"></v-divider>
                <label>Datos de contacto del abogado reconocido:</label>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Dirección de notificación"
                      v-model="editedItemAllegado.direccion_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Teléfono de contacto"
                      v-model="editedItemAllegado.telefono_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Celular de contacto"
                      v-model="editedItemAllegado.celular_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Correo electrónico"
                      v-model="editedItemAllegado.correo_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>
              </div>

              <v-divider class="mx-1"></v-divider>

              <v-textarea
                v-if="editedItemAllegado.abogado_reconocido_victima_principal === 'No'"
                v-model="editedItemAllegado.auto_reconocimiento_personeria_juridica_allegado"
                label="Auto reconocimiento personería jurídica:"
                hint="Brinde por favor la información correspondiente al auto de reconocimiento de personería jurídica."
              ></v-textarea>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog7 = false">Cancelar</v-btn>
            <v-btn color="primary" @click.prevent="updateAllegado()" v-if="boton_guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog8" persistent max-width="50%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE TRASLADOS</h4>
            </div>

            <div v-if="tableDataTraslados.length">
              <div v-if="tableDataTraslados[0].bloques.length">
                <v-data-table :headers="headersBloques" :items="tableDataTraslados[0].bloques" class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>
                      <a href="#" @click="obtenerResultadoTraslado(tableDataTraslados[0].id, props.item.id)">{{ props.item.nombre}} </a>
                    </td>
                  </template>
                </v-data-table>
              </div>
              <v-alert v-else color="lime darken-3" style="display:block">
                <label>No tiene bloques relacionados</label>
              </v-alert>
            </div>
            <v-alert v-else color="lime darken-3" style="display:block">
              <label>No tiene relación en traslados</label>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog8 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog9" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DEL DESPACHO</h4>
            </div>

            <h5 v-if="$auth.hasRole('Super Administrador')" class="headline mb-0 text-center">DATOS DE IDENTIFICACIÓN</h5>

            <section v-if="$auth.hasRole('Super Administrador')" class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select v-model="editedItem.tipos_documentos_id" :items="tipo_documentos" label="Tipo de documento * obligatorio" item-text="nombre" item-value="id" :rules="requiredRules">
                  </v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Número de documento * obligatorio" @change="verifica_identificacion_allegado" v-model="editedItem.no_identificacion" :rules="requiredRules" ></v-text-field>
                </div>
                
              </div>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Primer nombre * obligatorio" v-model="editedItem.nombre_victima_solicitante" :rules="requiredRules"></v-text-field>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Segundo nombre" v-model="editedItem.nombre2_victima_solicitante" ></v-text-field>
                </div>

              </div>
              
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
              
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field label="Primer apellido * obligatorio" v-model="editedItem.apellido1_victima_solicitante" :rules="requiredRules"></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field label="Segundo apellido" v-model="editedItem.apellido2_victima_solicitante" ></v-text-field>
                  </div>

              </div>
            </section>

            <h5 class="headline mb-0 text-center">DATOS RESIDENCIA</h5>

            <section class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">

                  <v-autocomplete
                    v-model="editedItem.departamento_id"
                    :items="src_departamentos"
                    label="Departamento residencia actual * obligatorio"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRules"
                    @change="trae_municipio"
                    hint="Escoja del desplegable el departamento que corresponda al lugar de residencia "
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>

                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.municipio_id"
                    :items="src_municipios"
                    label="Municipio residencia actual * obligatorio"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRules"
                    hint="Escoja del desplegable el municipio que corresponda al lugar de residencia "
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>
                </div>

              </div>

              <v-text-field label="Dirección: * obligatorio" :rules="requiredRules" v-model="editedItem.direccion" ></v-text-field>

            </section>

            <h5 class="headline mb-0 text-center">DATOS DE CONTACTO</h5>

            <section class="my-5 section-preview">

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItem.indicativo"
                    :items="indicativos"
                    label="Indicativo de ciudad para teléfono"
                  >
                  </v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Número de teléfono fijo * obligatorio" v-model="editedItem.telefono_fijo" :rules="requiredRules"></v-text-field>
                </div>

              </div>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Correo electrónico * obligatorio" v-model="editedItem.correo" :rules="[rules.email]"></v-text-field>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Número de teléfono celular * obligatorio" v-model="editedItem.telefono_celular" :rules="requiredRules"></v-text-field>
                </div>

              </div>

            </section>

            <h5 class="headline mb-0 text-center">HECHO VICTIMIZANTE</h5>

            <section class="my-5 section-preview">
              <v-divider class="mx-1"></v-divider>
              <label>Esta solicitud de acreditación la hago en razón de los siguientes hechos victimizantes:  </label>

              <v-textarea
                v-model="editedItem.hecho_victimizante"
                label="Relate los hechos:"
                hint="Brinde por favor un relato tan detallado como sea posible de los hechos, especificando su fecha, lugar de ocurrencia e información sobre presuntos responsables. Si desea en el siguiente campo puede adjuntar un documento con el relato de los hechos."
              ></v-textarea>

              <v-divider class="mx-1"></v-divider>
              <label>Indique si la/s víctima/s directa/s fueron dadas por desaparecidas:</label>
              <v-radio-group v-model='editedItem.victima_desaparecida' row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <v-divider class="mx-1"></v-divider>
              <label>Información fecha de los hechos victimizantes:  </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu v-model="menu_fecha_inicio_contrato" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="editedItem.fecha_hechos_inicio" label="Seleccione la fecha de inicio de los hechos" prepend-icon="event" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.fecha_hechos_inicio" @input="menu_fecha_inicio_contrato = false"></v-date-picker>
                  </v-menu>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu v-model="menu_fecha_fin_contrato" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="editedItem.fecha_hechos_fin" label="Seleccione la fecha de fin de los hechos" prepend-icon="event" readonly v-on="on" ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.fecha_hechos_fin" @input="menu_fecha_fin_contrato = false"></v-date-picker>
                  </v-menu>
                </div>

              </div>

              <v-divider class="mx-1"></v-divider>
              <label>Información del lugar de los hechos victimizantes:  </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.departamento_hechos_id"
                    :items="src_departamentos_hechos"
                    label="Departamento del lugar de los hechos"
                    item-text="nombre"
                    item-value="id"
                    @change="trae_municipio_hechos"
                    hint="Escoja del desplegable el departamento que corresponda al lugar de los hechos"
                  ></v-autocomplete>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.municipio_hechos_id"
                    :items="src_municipios_hechos"
                    label="Municipio del lugar de los hechos"
                    item-text="nombre"
                    item-value="id"
                    hint="Escoja del desplegable el municipio que corresponda al lugar de los hechos"
                  ></v-autocomplete>
                </div>

              </div>

              <v-textarea
              v-model="editedItem.lugar_hechos"
              label="Lugar de los hechos"
              hint="Si es posible, por favor, especifique el lugar exacto (corregimiento, vía, vereda, municipio, departamento en que tuvieron ocurrencia los hechos. Si es posible, en una hoja anexa, dibuje el lugar de ubicación exacta que complemente y permita determinar el lugar exacto de ocurrencia"
              ></v-textarea>

            </section>

            <section class="my-5 section-preview">
              <v-checkbox v-model="editedItem.fallecido" label="Fallecido"></v-checkbox>
            </section>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog9 = false">Cancelar</v-btn>
            <v-btn color="primary" @click.prevent="update" v-if="boton_guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog10" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE FAMILIARES Y ALLEGADOS DE {{editedItem.nombre_completo_victima_solicitante}}</h4>
            </div>
            <section class="my-5 section-preview">
              <span v-if="editedItem.allegados_familiares.length">
                  <div v-for="(item, index) in editedItem.allegados_familiares" :key="index">
                    <v-alert color="blue-grey" style="display:block">
                      <div
                        class="h1-responsive text-uppercase"
                        style="display:flex; justify-content: space-between;"
                      >
                        <div class="estilo_tres_columnas" style="padding-left:0px;">
                          <v-badge color="blue-grey darken-2">
                            <template v-slot:badge>{{index + 1}}.</template>
                          </v-badge>
                          <span
                            v-if="item.documento_allegado"
                            style="padding-left:25px;"
                          >Número documento: {{item.documento_allegado}}</span>
                          <span
                            v-if="item.parentezco_allegado"
                            style="padding-left:28px;"
                          >Parentesco: {{item.parentezco_allegado}}</span>
                        </div>

                        <div class="estilo_tres_columnas text-center" style="padding-left:0px;">
                          <span
                            v-if="item.nombre_allegado || item.nombre2_allegado || item.apellido1_allegado || item.apellido2_allegado"
                          >
                            Nombre completo:
                            <br />
                          </span>
                          <span v-if="item.nombre_allegado">{{item.nombre_allegado}}</span>
                          <span v-if="item.nombre2_allegado">{{item.nombre2_allegado}}</span>
                          <span v-if="item.apellido1_allegado">{{item.apellido1_allegado}}</span>
                          <span v-if="item.apellido2_allegado">{{item.apellido2_allegado}}</span>
                          <v-chip v-if="item.fallecido" color="red" text-color="white" title="Fallecido(a)">F</v-chip>
                        </div>

                        <div class="estilo_tres_columnas text-right" style="padding-left:0px;">
                          <span>
                            <br />
                          </span>
                          <v-icon
                            large
                            @click="gestionarAllegado(index, item)"
                          >edit</v-icon>
                          <v-icon
                            large
                            @click="eliminarAllegado(index, item)"
                          >delete</v-icon>
                        </div>
                      </div>
                    </v-alert>
                  </div>
                </span>
                <v-alert v-else color="lime darken-3" style="display:block">
                  <label>No tiene familiares ni allegados registrados</label>
                </v-alert>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog10 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog11" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE FAMILIARES Y ALLEGADOS</h4>
            </div>

            <h5 class="headline mb-0 text-center">EDITAR DATOS DE IDENTIFICACIÓN FAMILIAR / ALLEGADO</h5>
              <section class="my-5 section-preview">
                <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field label="Número de documento * obligatorio" @change="verifica_identificacion" v-model="editedItemAllegado.documento_allegado" :rules="requiredRules" ></v-text-field>
                  </div>

                </div>

                <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field label="Primer nombre * obligatorio" v-model="editedItemAllegado.nombre_allegado" :rules="requiredRules"></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field label="Segundo nombre" v-model="editedItemAllegado.nombre2_allegado" ></v-text-field>
                  </div>

                </div>

                <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer apellido * obligatorio" v-model="editedItemAllegado.apellido1_allegado" :rules="requiredRules"></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo apellido" v-model="editedItemAllegado.apellido2_allegado" ></v-text-field>
                    </div>

                </div>
                
              </section>
              
              <section class="my-5 section-preview">
                <v-checkbox v-model="editedItemAllegado.fallecido" label="Fallecido"></v-checkbox>
              </section>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialog11 = false">Cancelar</v-btn>
              <v-btn color="primary" @click.prevent="updateAllegadoDatosIdentificacion()" v-if="boton_guardar">Guardar</v-btn>
            </v-card-actions>
          
        </v-card>
      </v-dialog>

      <v-dialog v-model="mostrar_resultados" persistent>
        <v-card>
          <v-card-title class="headline text-uppercase">
            FORMULARIO DILIGENCIADO POR 
            {{tableDataTraslados[0] === undefined ? 'LA VICTIMA' : tableDataTraslados[0].nombre }} 
            {{tableDataTraslados[0] === undefined ? '' : obtenerBloqueTraslado(tableDataTraslados[0].bloques, parametros.bloque_id)[0] === undefined ? '' : ` - ${obtenerBloqueTraslado(tableDataTraslados[0].bloques, parametros.bloque_id)[0].nombre}` }}        </v-card-title>
          <v-card-text>
            <Respuestas></Respuestas>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success darken-1" text @click="descargarPdf()">Descargar PDF</v-btn>
            <v-btn color="red darken-1" text @click="mostrar_resultados = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer></v-spacer>
      <div class="card">
        <a
          href="/api/gestion_despacho_atencion_victimas_excel"
          tagert="_blank"
          v-if="$auth.hasRole('Administrador Despacho') || $auth.hasRole('Consulta Despacho') || $auth.hasRole('Super Administrador')"
        >
          <v-btn color="primary" dark class="mb-2">Excel Información Completa</v-btn>
        </a>
        <a
          href="/api/gestion_despacho_atencion_victimas_contacto_excel"
          tagert="_blank"
          v-if="$auth.hasRole('Consulta Secretaria')"
        >
          <v-btn color="primary" dark class="mb-2">Excel Información de Contacto</v-btn>
        </a>
        <a
          href="/publico/atencion_victimas"
          tagert="_blank"
          v-if="$auth.hasRole('Administrador Despacho') || $auth.hasRole('Super Administrador')"
        >
          <v-btn color="success" dark class="mb-2">Registrar Atención de victima</v-btn>
        </a>
      </div>
    </v-toolbar>

    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="tableData" :search="search" class="elevation-1">
      <template slot="items" slot-scope="props" v-if="props.item.nombre_victima_solicitante">
        <td>{{ props.item.nombre_completo_victima_solicitante }} <v-chip v-if="props.item.fallecido" color="red" text-color="white" title="Fallecido(a)">F</v-chip></td>
        <td>{{ props.item.codigo_registro }}</td>
        <td>{{ props.item.no_identificacion }}</td>
        <td class="text-center">
          <v-icon
            large
            color="red accent-4"
            v-if="props.item.estado==='No acreditada'"
            @click="gestionDespachoAcreditacion(props.item)"
          >verified_user</v-icon> 
          <v-icon
            large
            color="green accent-4"
            v-else-if="props.item.estado==='Acreditada'"
            @click="gestionDespachoAcreditacion(props.item)"
          >verified_user</v-icon>
          <v-icon
            large
            color="yellow accent-4"
            v-else
            @click="gestionDespachoAcreditacion(props.item)"
          >verified_user</v-icon>
        </td>
        <td class="text-center">
          <v-icon
            large
            color="red accent-4"
            v-if="props.item.reconocimiento_personeria_juridica!=='Reconocida'"
            @click="gestionDespachoReconocimiento(props.item)"
          >verified_user</v-icon>
          <v-icon
            large
            color="green accent-4"
            v-else
            @click="gestionDespachoReconocimiento(props.item)"
          >verified_user</v-icon>
        </td>
        <td class="text-center">
          <v-icon
            large
            color="green accent-4"
            v-if="props.item.traslado_tiene_respuesta"
            @click="gestionTraslados(props.item)"
          >verified_user</v-icon>
          <v-icon
            large
            color="red accent-4"
            v-else
            @click="gestionTraslados(props.item)"
          >verified_user</v-icon>
        </td>
        <td class="text-center">
          <v-icon
            small
            class="done"
            @click="gestionRegistro(props.item)"
            v-if="$auth.hasRole('Administrador Despacho') || $auth.hasRole('Super Administrador')"
          >edit</v-icon>
          <v-icon
            small
            class="done"
            @click="exportar_pdf(props.item)"
            v-if="$auth.hasRole('Administrador Despacho') || $auth.hasRole('Consulta Despacho') || $auth.hasRole('Super Administrador')"
          >get_app</v-icon>
          <v-icon
            small
            class="done"
            @click="showItem(props.item)"
            v-if="$auth.hasRole('Administrador Despacho') || $auth.hasRole('Consulta Despacho') || $auth.hasRole('Super Administrador')"
          >visibility</v-icon>
          <v-icon
            small
            class="done"
            @click="showFiles(props.item.no_identificacion)"
            v-if="$auth.hasRole('Administrador Despacho') || $auth.hasRole('Consulta Despacho') || $auth.hasRole('Super Administrador')"
          >attach_file</v-icon>
          <v-icon
            small
            class="done"
            @click="gestionarAllegados(props.item)"
            v-if="$auth.hasRole('Super Administrador')"
          >group</v-icon>
          <v-icon
            small
            class="done"
            @click="deleteItem(props.item)"
            v-if="$auth.hasRole('Super Administrador')"
          >delete</v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { EventBus } from "../EventBus";
import Traslado from "../services/Traslado";
import CargarDocumento from "../components/CargarDocumento";
// import Alertifyjs from 'vue2-alertifyjs'
import alertify from 'alertifyjs';


export default {
  data: () => ({
    step: 1,
    valid: true,
    dialog: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialog5: false,
    dialog6: false,
    dialog7: false,
    dialog8: false,
    dialog9: false,
    dialog10: false,
    dialog11: false,
    mostrar_resultados: false,
    search: "",
    headersFiles: [{ text: "Nombre Archivo", value: "nombres" }],
    headersBloques: [{ text: "Nombre Bloque", value: "nombre" }],
    headers: [
      { text: "NOMBRE COMPLETO", value: "nombre_completo_victima_solicitante" },
      { text: "NÚMERO RADICADO JEP", value: "codigo_registro" },
      { text: "IDENTIFICACIÓN", value: "no_identificacion" },
      { text: "ACREDITACIÓN", value: "activo", align: 'start' },
      { text: "PERSONERÍA JURÍDICA", value: "activo", align: 'start' },
      { text: "TRASLADOS", value: "traslado_tiene_respuesta", align: 'start' },
      { text: "ACCIONES", value: "name", sortable: false, align: 'start' }
    ],
    boton_guardar: true,
    tableData: [],
    tableDataFiles: [],
    tableDataTraslados: [],
    editedIndex: -1,
    editedIndexAllegado: -1,
    etnias: [],
    generos: [],
    parametros: {},
    estados: ["No acreditada", "Acreditada"],
    reconocimiento_personeria_juridica: ["No reconocida", "Reconocida"],
    abogado_reconocido_victima_principal: ["Sí", "No"],
    departamentos: ["Boyacá", "Santander"],
    municipios: ["Tunja", "Barbosa"],
    bloques: ["BLOQUE CARIBE"],
    frentes: [
      "FRENTE 19 JOSE PRUDENCIA PADILLA",
      "FRENTE 35 ANTONIO JOSE DE SUCRE",
      "FRENTE 37 BENKOS BIOHO",
      "FRENTE 41 CACIQUE DE UPAR",
      "FRENTE 59 RESISTENCIA GUAJIRA",
      "RED URBANA JOSE ANTEQUERA"
    ],
    documentos_requeridos: [
      "Vigencia tarjeta profesional",
      "Penales",
      "Contravencionales",
      "Disciplinarios CSJ",
      "Diciplinarios PGN"
    ],
    src_departamentos:[],
    src_municipios:[],
    src_departamentos_hechos:[],
    src_municipios_hechos:[],
    indicativos:['4 - ANTIOQUIA','5 - ATLÁNTICO','1 - BOGOTÁ D.C.','5 - BOLÍVAR','8 - BOYACÁ','6 - CALDAS','8 - CAQUETÁ','2 - CAUCA','5 - CESAR','4 - CÓRDOBA','1- CUNDINAMARCA','4- CHOCO','8 - HUILA','5 - GUAJIRA','5 - MAGDALENA','8 - META','2 - NARIÑO','7 - NORTE DE SANTANDER','6 - QUINDÍO','6 - RISARALDA','7 - SANTANDER','5 - SUCRE','8 - TOLIMA','2 - VALLE DEL CAUCA','7 - ARAUCA','8 - CASANARE','8 - PUTUMAYO','8 - SAN ANDRÉS Y PROVIDENCIA','8 - AMAZONAS','8 - GUAINÍA','8 - GUAVIARE','8 VAUPÉS','8 - VICHADA'],
    sexos: [],
    tipo_documentos: [],
    documento: "",
    enfoques_abogado: [],
    tipos_abogado: [],
    menu: "",
    menu_fecha_titulo: [],
    menu_fecha_ingreso: [],
    menu_fecha_salida: [],
    menu_fecha_inicio_contrato: false,
    menu_fecha_fin_contrato: false,
    menu_fecha_acreditacion: false,
    menu_fecha_acreditacion_allegado: false,
    menu_fecha_auto_reconocimiento_personeria_juridica: false,
    menu_fecha_auto_reconocimiento_personeria_juridica_allegado: false,
    num_docs: 1,
    openFileDialog: [],
    date: "",
    items_educa: 0,
    file: {},
    selected_archivo: {},
    upload_success: false,
    upload_failed: false,
    spinner_on: false,
    documento: "",
    educa: {
      id: -1,
      universidad: "",
      grado: "",
      titulo: "",
      pais: "",
      pre_pos: ""
    },
    items_educa: 0,
    pres_resp: {
      id: -1,
      nombre_responsable: "",
      alias_responsable: "",
      estructura_responsable: ""
    },
    fami_alle: {
      id: -1,
      nombre_allegado: "",
      documento_allegado: "",
      parentezco_allegado: "",
      adjunto_allegado: ""
    },
    editedItem: {
      solicitud_anterior: "",
      no_registro_victima: "",
      formulario_propio: "",
      persona_victima: "",
      nombre_victima_solicitante: "",
      nombre2_victima_solicitante: "",
      apellido1_victima_solicitante: "",
      apellido2_victima_solicitante: "",
      departamento_nacimiento_id: "",
      municipio_nacimiento_id: "",
      fecha_nacimiento: "",
      departamento_id: "",
      municipio_id: "",
      direccion: "",
      grupo_etnico: "",
      nombre_grupo_etnico: "",
      organizacion_victimas: "",
      nombre_organizacion_victimas: "",
      sujeto_colectivo: "",
      nombre_sujeto_colectivo: "",
      indicativo: "",
      telefono_fijo: "",
      telefono_celular: "",
      correo: "",
      ocupacion_actual: "",
      hecho_victimizante: "",
      fecha_hechos_inicio: "",
      fecha_hechos_fin: "",
      departamento_hechos_id: "",
      municipio_hechos_id: "",
      lugar_hechos: "",
      abogado_confianza: "",
      nombre_abogado: "",
      nombre2_abogado: "",
      apellido1_abogado: "",
      apellido2_abogado: "",
      direccion_abogado: "",
      telefono_abogado: "",
      celular_abogado: "",
      correo_abogado: "",
      adjunto_poder_abogado: "",
      poder_abogado: "",
      representado_actualmente_jep: "",
      manifiesta_interes: "",
      voluntad_actuar_solo: "",
      medio_representacion: "",
      riesgo_seguridad: "",
      razones_riesgo_seguridad: "",
      riesgo_seguridad_pruebas: "",
      razones_riesgo_seguridad_pruebas: "",
      autoriza_notificacion: "",
      estado: "",
      auto_reconocimiento_personeria_juridica: "",
      fecha_auto_reconocimiento_personeria_juridica: "",
      demanda_verdad: "",
      tarjeta_profesional: "",
      tipos_abogados_id: 1,
      role: {},
      permissions: [],
      presuntos_responsables: [],
      allegados_familiares: [],
      files_to_upload: [],
      adjuntos: [],
      created_at: "",
      fallecido: false
    },
    editedItemAllegado: {
      estado_allegado: "",
      observaciones_allegado: "",
      fecha_acreditacion_allegado: "",

      abogado_reconocido_victima_principal: "",
      reconocimiento_personeria_juridica_allegado: "",
      fecha_auto_reconocimiento_personeria_juridica_allegado: "",
      auto_reconocimiento_personeria_juridica_allegado: "",

      nombre_abogado_reconocido_allegado: "",
      nombre2_abogado_reconocido_allegado: "",
      apellido1_abogado_reconocido_allegado: "",
      apellido2_abogado_reconocido_allegado: "",
      direccion_abogado_reconocido_allegado: "",
      telefono_abogado_reconocido_allegado: "",
      celular_abogado_reconocido_allegado: "",
      correo_abogado_reconocido_allegado: ""
    },
    defaultItem: {
      name: "",
      email: "",
      tarjeta_profesional: "",
      tipos_abogados_id: 1,
      role: {},
      permissions: [],
      presuntos_responsables: [],
      allegados_familiares: [],
      files_to_upload: [],
      created_at: ""
    },
    rules: {
      required: value => !!value || 'Este campo es obligatorio',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Correo Electrónico Invalido.'
      },
      email_vacio: value => {
        const pattern =  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        return pattern.test(value) ||!value || 'Correo Electrónico Invalido'
      },
      number_vacio: value => {
        const pattern =  /^\d+(\.\d)?$/
        return pattern.test(value) ||!value || 'Este campo debe contener dígitos únicamente'
      },
    },
    requiredRules: [
      v => !!v || "Este campo es obligatorio"
      //v => /^\d+(\.\d)?$/.test(v) || 'Número de documento debe contener dígitos únicamente'
    ]
  }),
  components: {
    "cargar-documento": CargarDocumento
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Registrar abogado" : "Editar abogado";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    "editedItem.reconocimiento_personeria_juridica": function(valor) {
      this.reseteoDatosAbogadoReconocido();
    },
    "editedItemAllegado.abogado_reconocido_victima_principal": function(valor) {
      if (valor === "Sí") {
        this.editedItemAllegado.reconocimiento_personeria_juridica_allegado =
          "";
        this.editedItemAllegado.auto_reconocimiento_personeria_juridica_allegado =
          "";
        this.editedItemAllegado.fecha_auto_reconocimiento_personeria_juridica_allegado =
          "";
        this.reseteoDatosAbogadoReconocidoAllegado();
      }
    },
    "editedItemAllegado.reconocimiento_personeria_juridica_allegado": function(
      valor
    ) {
      if (valor === "No reconocida") {
        this.reseteoDatosAbogadoReconocidoAllegado();
      }
    }
  },
  created() {
    this.initialize();
    // console.log($vuetify.breakpoint)
  },
  mounted() {
    let vm = this;

    // vm.$notify('TEST','success')
    this.num_docs = 1;
    // EventBus.$on('file-upload-success', (id) => {
    //      this.openFileDialog[id]=false;
    //      // this.editedItem.adjunto_tarjeta_profesional=event.target.files[0];
    //      console.log(id);
    //    });
    EventBus.$on("file-to-upload", (file_to_upload, nombreAdjunto) => {
      // this.openFileDialog=false;
      this.editedItem.files_to_upload[nombreAdjunto] = file_to_upload;
      // this.editedItem.this[nombreAdjunto]=file_to_upload;
      console.log("Archivo recibido = " + file_to_upload);
      // console.log(this.editedItem.this[nombreAdjunto]);
      console.log(this.editedItem);
      // this.no_upload[this.num_docs]=false;
    });
  },
  methods: {
    initialize() {
      // this.editedItem.educacion.push(Object.assign({},this.educa));
      // this.editedItem.experiencia.push(Object.assign({},this.experiencia));
      // console.log(this.editedItem)
      axios.get("/api/atencion_victimas").then(response => {
        this.tableData = response.data.data;
      });

      axios
        .get("/api/roles")
        .then(response => (this.allRoles = response.data.data));
      axios
        .get("/api/permissions")
        .then(response => (this.allPermissions = response.data.data));

      axios.get('/api/departamentos').then(response=>this.src_departamentos=response.data.data);
      axios.get('/api/departamentos').then(response=>this.src_departamentos_hechos=response.data.data);
      axios.get("/api/tipo_documentos").then(response => {this.tipo_documentos=response.data.data;});


      // axios.get('/api/tipo_documentos').then(response => {
      //   this.tipo_documentos=response.data.data;
      // });
      //
      // axios.get('/api/sexos').then(response => {
      //   this.sexos=response.data.data;
      // });
      //
      // axios.get('/api/generos').then(response => {
      //   this.generos=response.data.data;
      // });
      //
      // axios.get('/api/etnias').then(response => {
      //   this.etnias=response.data.data;
      // });
      //
      // axios.get('/api/enfoques_abogado').then(response => {
      //   this.enfoques_abogado=response.data.data;
      // });
      //
      // axios.get('/api/tipos_abogado').then(response => {
      //   this.tipos_abogado=response.data.data;
      // });
    },
    editItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    showItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog2 = true;
    },
    trae_municipio() {
      axios.get('/api/municipios/'+this.editedItem.departamento_id).then(response=>this.src_municipios=response.data.data);
    },
    trae_municipio_hechos() {
      axios.get('/api/municipios/'+this.editedItem.departamento_hechos_id).then(response=>this.src_municipios_hechos=response.data.data);
    },
    gestionDespachoAcreditacion(item) {
      if (this.$auth.hasRole("Administrador Despacho") || this.$auth.hasRole("Super Administrador")) {
        this.editedIndex = this.tableData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog4 = true;
      }
    },
    gestionDespachoAcreditacionFamiliar(index, item) {
      if (this.$auth.hasRole("Administrador Despacho") || this.$auth.hasRole("Super Administrador")) {
        this.editedIndexAllegado = index;
        this.editedItemAllegado = Object.assign({}, item);

        this.dialog6 = true;
      }
    },
    gestionDespachoReconocimiento(item) {
      if (this.$auth.hasRole("Administrador Despacho")) {
        this.editedIndex = this.tableData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog5 = true;
      }
    },
    gestionRegistro(item) {

      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);

      const departamentoId = this.editedItem.departamento_id ? this.editedItem.departamento_id.id : 0;
      const departamentoIdHechos = this.editedItem.departamento_hechos_id ? this.editedItem.departamento_hechos_id.id : 0;

      const listadoMunicipios = axios.get(`/api/municipios/${departamentoId}`);
      const listadoMunicipiosHechos = axios.get(`/api/municipios/${departamentoIdHechos}`);

      axios.all([listadoMunicipios, listadoMunicipiosHechos])
      .then(
        axios.spread((...responses) => {
          console.log(responses)
          this.src_municipios = responses[0].data.data
          this.src_municipios_hechos = responses[1].data.data
          this.dialog9 = true;
      }))
    },
    gestionarAllegados(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog10 = true;
    },
    gestionarAllegado(index, item) {
      this.editedIndexAllegado = index;
      this.editedItemAllegado = {
        ...item
      };

      this.dialog11 = true;
    },
    updateAllegadoDatosIdentificacion() {
      //console.log("updateAllegadoDatosIdentificacion");
      //console.log(this.editedItemAllegado);

      axios
        .put(
          `/api/gestion_despacho_atencion_victimas_familiar_allegado_datos_identificacion/${this.editedItemAllegado.id}`,
          this.editedItemAllegado
        )
        .then(response => {
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].nombre_allegado = this.editedItemAllegado.nombre_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].nombre2_allegado = this.editedItemAllegado.nombre2_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].apellido1_allegado = this.editedItemAllegado.apellido1_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].apellido2_allegado = this.editedItemAllegado.apellido2_allegado;

          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].documento_allegado = this.editedItemAllegado.documento_allegado;

          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].fallecido = this.editedItemAllegado.fallecido;
          
          this.dialog11 = false;
        });
    },
    eliminarAllegado(index, item) {
      //const index = this.tableData.indexOf(item);

      // Mostrar el diálogo de confirmación
      alertify.confirm('Confirmar eliminación', '¿Estás seguro de que quieres eliminar este elemento?',
        () => {
          // Acción de eliminar si se confirma
          axios
            .delete("/api/atencion_victimas_eliminar_allegado/" + item.id)
            .then(response => {
              // Si la respuesta es satisfactoria, realizar la eliminación en la tabla
              if (response.status === 200) {
                // Eliminar el elemento del array
                this.editedItem.allegados_familiares.splice(index, 1);
              } else {
                // Si la respuesta no es satisfactoria, mostrar un mensaje de error
                alertify.error('No se pudo eliminar el elemento.');
              }
            })
            .catch(error => {
              // Manejar errores de la petición
              console.error('Error al eliminar el elemento:', error);
              alertify.error('Error al eliminar el elemento.');
            });
        },
        () => {
          // Acción si se cancela
        }
      );
    },
    gestionDespachoReconocimientoFamiliar(index, item) {
      if (this.$auth.hasRole("Administrador Despacho")) {
        // console.log("item");
        // console.log(item);
        this.editedIndexAllegado = index;
        // this.editedItemAllegado = Object.assign({}, item);
        this.editedItemAllegado = {
          ...item
        };
        // console.log("this.editedItemAllegado");
        // console.log(this.editedItemAllegado);
        this.dialog7 = true;
      }
    },
    gestionTraslados(item) {
      if (this.$auth.hasRole("Administrador Despacho")) {
        this.editedIndex = this.tableData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        console.log(this.editedItem.no_identificacion);
        this.tableDataTraslados = [];
        let documento = this.editedItem.no_identificacion
        axios.get(`/api/traslados/personas/${documento}/victima`).then(response => {
          console.log(response.data.data);
          this.tableDataTraslados = response.data.data;
        });
        this.dialog8 = true;
      }
    },
    obtenerResultadoTraslado(persona, bloque) {
      this.mostrar_resultados = true;
      this.parametros = {
        persona_id: persona,
        bloque_id: bloque,
        tipo_usuario: "despacho",
        usuario_id: this.$auth.user.user.id
      };
      EventBus.$emit("parametros", this.parametros);
    },
    obtenerBloqueTraslado(bloques, bloque_id) {
      return bloques.filter(x => x.id === bloque_id);
    },
    descargarPdf() {

      let persona_id = this.parametros.persona_id;
      let bloque_id = this.parametros.bloque_id;

      this.show_export_spinner = true;

      let ruta = `/api/traslados/personas/${persona_id}/bloque/${bloque_id}/respuestas/pdf`;
      Traslado.getObtenerPDFResultadoTrasladoXBloque(persona_id, bloque_id)
        .then(response => {
          this.show_export_spinner = false;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "formulario_traslado.pdf"); //or any other extension

          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log("Ha ocurrido un error en la exportación a PDF");
          this.show_export_spinner = false;
        });
    },
    reseteoDatosAbogadoReconocido() {
      this.editedItem.nombre_abogado_reconocido = "";
      this.editedItem.nombre2_abogado_reconocido = "";
      this.editedItem.apellido1_abogado_reconocido = "";
      this.editedItem.apellido2_abogado_reconocido = "";
      this.editedItem.direccion_abogado_reconocido = "";
      this.editedItem.telefono_abogado_reconocido = "";
      this.editedItem.celular_abogado_reconocido = "";
      this.editedItem.correo_abogado_reconocido = "";
    },
    reseteoDatosAbogadoReconocidoAllegado() {
      this.editedItemAllegado.nombre_abogado_reconocido_allegado = "";
      this.editedItemAllegado.nombre2_abogado_reconocido_allegado = "";
      this.editedItemAllegado.apellido1_abogado_reconocido_allegado = "";
      this.editedItemAllegado.apellido2_abogado_reconocido_allegado = "";
      this.editedItemAllegado.direccion_abogado_reconocido_allegado = "";
      this.editedItemAllegado.telefono_abogado_reconocido_allegado = "";
      this.editedItemAllegado.celular_abogado_reconocido_allegado = "";
      this.editedItemAllegado.correo_abogado_reconocido_allegado = "";
    },
    verifica_identificacion() {
        axios.get("/api/verifica_identificacion/"+this.editedItem.no_identificacion).then((response) => {
          console.log(response);
          if(response.data==1)
          {
            alert("Ya ha sido registrada una Solicitud de Acreditación como víctima del caso No. 01 asociada a este número de identificación " + this.editedItem.no_identificacion + ".");
            this.editedItem.no_identificacion="";
          }
        });
      },
      verifica_identificacion_allegado() {
        
      },
    update() {
      // console.log(this.editedItem);
      Object.assign(this.tableData[this.editedIndex], this.editedItem);
      axios
        .put(
          "/api/gestion_despacho_atencion_victimas/" + this.editedItem.id,
          this.editedItem
        )
        .then(response => {
          this.dialog4 = false;
          this.dialog5 = false;
          this.dialog9 = false; 
          
          this.$set(this.tableData[this.editedIndex], 'nombre_completo_victima_solicitante', response.data.registro.nombre_completo_victima_solicitante);
                
        });
    },
    updateAllegado() {
      // console.log("updateAllegado");
      // console.log(this.editedItemAllegado.id);

      axios
        .put(
          `/api/gestion_despacho_atencion_victimas_familiar_allegado/${this.editedItemAllegado.id}`,
          this.editedItemAllegado
        )
        .then(response => {
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].estado_allegado = this.editedItemAllegado.estado_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].observaciones_allegado = this.editedItemAllegado.observaciones_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].fecha_acreditacion_allegado = this.editedItemAllegado.fecha_acreditacion_allegado;

          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].abogado_reconocido_victima_principal = this.editedItemAllegado.abogado_reconocido_victima_principal;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].reconocimiento_personeria_juridica_allegado = this.editedItemAllegado.reconocimiento_personeria_juridica_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].fecha_auto_reconocimiento_personeria_juridica_allegado = this.editedItemAllegado.fecha_auto_reconocimiento_personeria_juridica_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].auto_reconocimiento_personeria_juridica_allegado = this.editedItemAllegado.auto_reconocimiento_personeria_juridica_allegado;

          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].nombre_abogado_reconocido_allegado = this.editedItemAllegado.nombre_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].nombre2_abogado_reconocido_allegado = this.editedItemAllegado.nombre2_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].apellido1_abogado_reconocido_allegado = this.editedItemAllegado.apellido1_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].apellido2_abogado_reconocido_allegado = this.editedItemAllegado.apellido2_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].direccion_abogado_reconocido_allegado = this.editedItemAllegado.direccion_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].telefono_abogado_reconocido_allegado = this.editedItemAllegado.telefono_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].celular_abogado_reconocido_allegado = this.editedItemAllegado.celular_abogado_reconocido_allegado;
          this.editedItem.allegados_familiares[
            this.editedIndexAllegado
          ].correo_abogado_reconocido_allegado = this.editedItemAllegado.correo_abogado_reconocido_allegado;

          this.dialog6 = false;
          this.dialog7 = false;
        });
    },
    showFiles(item) {
      this.tableDataFiles = [];
      axios.get("/api/showfiles/" + item).then(response => {
        // console.log(response);
        this.tableDataFiles = response.data;
      });
      this.dialog3 = true;
    },
    deleteItem(item) {
      const index = this.tableData.indexOf(item);

      // Mostrar el diálogo de confirmación
      alertify.confirm('Confirmar eliminación', '¿Estás seguro de que quieres eliminar este elemento?',
        () => {
          // Acción de eliminar si se confirma
          axios
            .delete("/api/atencion_victimas/" + item.id)
            .then(response => {
              // Si la respuesta es satisfactoria, realizar la eliminación en la tabla
              if (response.status === 200) {
                // Eliminar el elemento del array
                this.tableData.splice(index, 1);
              } else {
                // Si la respuesta no es satisfactoria, mostrar un mensaje de error
                alertify.error('No se pudo eliminar el elemento.');
              }
            })
            .catch(error => {
              // Manejar errores de la petición
              console.error('Error al eliminar el elemento:', error);
              alertify.error('Error al eliminar el elemento.');
            });
        },
        () => {
          // Acción si se cancela
        }
      );
    },
    validate(form_s, next_step) {
      if (form_s.validate()) {
        this.step = next_step;
      }
    },
    add_pres_resp() {
      // this.items_educa++;
      this.editedItem.presuntos_responsables.push(
        Object.assign({}, this.pres_resp)
      );
    },
    less_pres_resp(index) {
      this.$delete(this.editedItem.presuntos_responsables, index);
    },
    add_allegados() {
      // this.items_educa++;
      this.editedItem.allegados_familiares.push(
        Object.assign({}, this.fami_alle)
      );
    },
    less_allegados(index) {
      this.$delete(this.editedItem.allegados_familiares, index);
    },
    exportar_pdf(item) {
      var cont = 0;

      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // debugger

      Object.entries(this.editedItem.files_to_upload).forEach(([key, val]) => {
        // console.log(key); // the name of the current key.
        // console.log(val); // the value of the current key.
        this.file = val;

        // this.file = item.files_to_upload['"'+element+'"'];
        this.editedItem.adjuntos[key] = this.file.name;

        // eval("item."+key+" = this.file.name");
        // eval("item.adjunto01 = this.file.name");
        // eval("dynamic" + i + " = val[i]");
        // var formData = new FormData();
        // formData.append('archivo', this.file);
        // formData.append('nombre_adjunto', key);
        // formData.append('identificacion', t);
        // console.log("A guardar = "+this.file.name);
        // axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        cont++;
      });

      this.show_export_spinner = true;
      // debugger

      axios({
        url: "/guardar_pdf",
        params: { id: this.editedItem.id },
        method: "GET",
        responseType: "blob" // important
      })
        .then(response => {
          // console.log(response);
          // this.show_export_spinner=false;
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "formulario_registro.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.show_export_spinner = false;
          // console.log(error);
        });
    },
    init_reg() {
      // this.items_educa++;

      // (!this.editedItem.educacion) ? this.editedItem.educacion = Object.assign({}, this.educa) : console.log("SI existe");;
      // this.editedItem.educacion = Object.assign({}, this.educa);
      // if(this.editedItem.educacion)
      // {
      //this.editedItem.educacion = {};
      this.editedItem.presuntos_responsables.push(
        Object.assign({}, this.pres_resp)
      );
      this.editedItem.allegados_familiares.push(
        Object.assign({}, this.fami_alle)
      );

      this.$refs.form_step_1.reset();
      this.$refs.form_step_2.reset();
      this.$refs.form_step_3.reset();
      this.$refs.form_step_4.reset();
      this.$refs.form_step_5.reset();
      //  }
      // (!this.editedItem.educacion)?this.editedItem.educacion.push(Object.assign({},this.educa));
    },
    agregar_documento() {
      this.openFileDialog[this.num_docs] = true;
      // console.log("el documento para open = "+documento);
      // this.openFileDialog[1]=true;
      this.num_docs++;
    },
    delete_skillset(id_set) {
      this.items_educa++;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      // console.log("Entro a save");
      //  documentos_requeridos:['Vigencia tarjeta profesional','Penales','Contravencionales','Disciplinarios CSJ', 'Diciplinarios PGN'],
      // <!-- <v-text-field label="Adjuntar Vigencia tarjeta profesional (PDF)"  v-model='editedItem.adjunto_tarjeta_profesional' prepend-icon='attach_file'></v-text-field>
      // <v-text-field label="Adjuntar Penales (PDF)"  v-model='editedItem.adjunto_penales' prepend-icon='attach_file'></v-text-field>
      // <v-text-field label="Adjuntar Contravencionales (PDF)"  v-model='editedItem.adjunto_contavencionales' prepend-icon='attach_file'></v-text-field>
      // <v-text-field label="Adjuntar Disciplinarios CSJ (PDF)"  v-model='editedItem.adjunto_csj' prepend-icon='attach_file'></v-text-field>
      // <v-text-field label="Adjuntar Disciplinarios PGN (PDF)"  v-model='editedItem.adjunto_pgn' prepend-icon='attach_file'></v-text-field> -->

      if (this.editedItem.files_to_upload) {
        // console.log("Si existe files_to_upload");

        // this.documentos_requeridos.forEach(function(elemento) {
        //   console.log("en el array = "+elemento);
        //   if(this.editedItem.files_to_upload['"'+element+'"'])
        //   {
        //     this.editedItem.adjunto_tarjeta_profesional=this.editedItem.files_to_upload['"'+element+'"'].name
        //     this.file = this.editedItem.files_to_upload['"'+element+'"'];
        //
        //     var formData = new FormData();
        //     formData.append('archivo', this.file);
        //     formData.append('identificacion', this.editedItem.no_identificacion);
        //     console.log("A guardar = "+this.file.name);
        //     axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        //   }

        // });

        // if(this.editedItem.files_to_upload['Vigencia tarjeta profesional'])
        // {
        //       this.editedItem.adjunto_tarjeta_profesional=this.editedItem.files_to_upload['Vigencia tarjeta profesional'].name
        //     this.file = this.editedItem.files_to_upload['Vigencia tarjeta profesional'];
        //
        //     var formData = new FormData();
        //     formData.append('archivo', this.file);
        //     formData.append('identificacion', this.editedItem.no_identificacion);
        //     console.log("A guardar = "+this.file.name);
        //     axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        // }
        //
        // if(this.editedItem.files_to_upload['Disciplinarios CSJ'])
        // {
        //       this.editedItem.adjunto_csj=this.editedItem.files_to_upload['Disciplinarios CSJ'].name
        //     this.file = this.editedItem.files_to_upload['Disciplinarios CSJ'];
        //
        //     var formData = new FormData();
        //     formData.append('archivo', this.file);
        //     formData.append('identificacion', this.editedItem.no_identificacion);
        //     console.log("A guardar = "+this.file.name);
        //     axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        // }
        //
        // if(this.editedItem.files_to_upload['Penales'])
        // {
        //       this.editedItem.adjunto_penales=this.editedItem.files_to_upload['Penales'].name
        //     this.file = this.editedItem.files_to_upload['Penales'];
        //
        //     var formData = new FormData();
        //     formData.append('archivo', this.file);
        //     formData.append('identificacion', this.editedItem.no_identificacion);
        //     console.log("A guardar = "+this.file.name);
        //     axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        // }
        //
        // if(this.editedItem.files_to_upload['Contravencionales'])
        // {
        //       this.editedItem.adjunto_contravencionales=this.editedItem.files_to_upload['Contravencionales'].name
        //     this.file = this.editedItem.files_to_upload['Contravencionales'];
        //
        //     var formData = new FormData();
        //     formData.append('archivo', this.file);
        //     formData.append('identificacion', this.editedItem.no_identificacion);
        //     console.log("A guardar = "+this.file.name);
        //     axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        // }
        //
        // if(this.editedItem.files_to_upload['Diciplinarios PGN'])
        // {
        //       this.editedItem.adjunto_pgn=this.editedItem.files_to_upload['Diciplinarios PGN'].name
        //     this.file = this.editedItem.files_to_upload['Diciplinarios PGN'];
        //
        //     var formData = new FormData();
        //     formData.append('archivo', this.file);
        //     formData.append('identificacion', this.editedItem.no_identificacion);
        //     console.log("A guardar = "+this.file.name);
        //     axios.post('/api/uploadFile',formData).then(response=>console.log(response.data));
        // }
      }
      if (this.editedIndex > -1) {
        // console.log("Entró a update");
        Object.assign(this.tableData[this.editedIndex], this.editedItem);

        axios
          .put("/api/atencion_victimas/" + this.editedItem.id, this.editedItem)
          .then(response => console.log(response.data));
      } else {
        // console.log("Entró a save");

        // console.log(this.editedItem)
        axios.post("/api/atencion_victimas", this.editedItem).then(response => {
          this.tableData.push(response.data.abogado);
          // console.log(response.data)
        });
      }
      this.close();
    }
  }
};
</script>

<style scoped>
.section-preview {
  border: 1px solid #e0e0e0;
  padding: 15px;
}

.datos-radicado {
  display: flex;
  justify-content: space-between;
}

.estilo_dos_columnas {
  width: 50%;
  margin-left: 5px;
  margin-top: 5px;
}

.estilo_tres_columnas {
  width: 33%;
  padding-right: 10px;
  padding-top: 15px;
}
</style>
